import {
  FETCH_PILLS_REQUEST,
  FETCH_PILLS_SUCCESS,
  FETCH_PILLS_FAILURE,
  SET_PILLS_KEYWORD
} from "../store/actionTypes";

interface PillCategory {
  id: string;
  label: string;
  type: 'application' | 'platform';
  suggestions: string[];
}

interface PillsState {
  pills: PillCategory[];
  isLoading: boolean;
  error: string | null;
  keyword: string;
}

interface Action {
  type: string;
  payload?: any;
}

const initialState: PillsState = {
  pills: [],
  isLoading: false,
  error: null,
  keyword: "",
};

const pillsReducer = (state = initialState, action: Action): PillsState => {
  switch (action.type) {
    case FETCH_PILLS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case FETCH_PILLS_SUCCESS:
      // Ensure we always store an array, even if API returns something else
      const pills = Array.isArray(action.payload) ? action.payload : [];
      return { ...state, isLoading: false, pills };
    case FETCH_PILLS_FAILURE:
      return { ...state, isLoading: false, error: action.payload, pills: [] };
    case SET_PILLS_KEYWORD:
      return { ...state, keyword: action.payload };
    default:
      return state;
  }
};

export default pillsReducer; 